import React from "react";
import CartProvider from "../../providers/CartProvider";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppProps } from "../BaseApp";
import OrderProvider from "../../providers/OrderProvider";
import CustomToastContainer from "../../../shared/ui/custom-toast-container";
import { QueryClientProvider } from "@tanstack/react-query";
import Payment from "../../../pages/payment";
import AnalyticsProvider from "app/providers/AnalyticsProvider";
import { queryClient } from "../queryClient";

const App: React.FC<AppProps> = (props, context) => {
  const getBasename = (): string => {
    return props.configuration.basename || "betalen";
  };

  return (
    <div className="gg">
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <AnalyticsProvider>
            <CartProvider>
              <OrderProvider>
                <CustomToastContainer />
                <Routes>
                  <Route path={getBasename()} element={<Payment />} />
                </Routes>
              </OrderProvider>
            </CartProvider>
          </AnalyticsProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </div>
  );
};

export default App;
